/*
 *
 *  * *****************************************************************************
 *  *  Copyright (C) 2020 Testsigma Technologies Inc.
 *  *  All rights reserved.
 *  *  ****************************************************************************
 *
 */

export enum TestStepConditionType {
  CONDITION_IF = "CONDITION_IF",
  CONDITION_ELSE_IF = "CONDITION_ELSE_IF",
  CONDITION_ELSE = "CONDITION_ELSE",
  LOOP_FOR = "LOOP_FOR",
  LOOP_WHILE="LOOP_WHILE",
  NOT_USED = "NOT_USED"
}
